
import { mapGetters } from 'vuex';
export default {
	components:{
		breadcrumbs: () => import('../../components/pages/breadcrumbs.vue'),
		registerPage: () => import('../../components/account/register-page.vue')
	},
    computed: {
        ...mapGetters({
            getterTranslates: 'getterTranslates',
            getterStoreLang: 'getterStoreLang'
        })
    }
}
